<app-timesheet-list *ngIf="!TimesheetEditList" [ListInputProperty]="isListorUpdateView"
  (ListOutputTimesheet)="EmitChildComponent($event)"></app-timesheet-list>



<app-timesheet-edit *ngIf="TimesheetEditList" [EditInputProperty]="isListorUpdateView"
  (EditOutputTimesheet)="EmitChildComponent($event)"></app-timesheet-edit>